export enum WindowMode {
    Home,
    Normal
}
